import {parseScaleWeight, sendToScales} from '../helpers/print/scales';

export default {
  methods: {
    getWeight: async function(){
      try{
        await sendToScales(this.setWeight);
      } catch(e){
        this.$store.dispatch('errorModal/displayModalError', {
          modalId: 'scale-error',
          errorBody: {
            title: 'Scales error',
            info: 'Can not connect to scales'
          }
        });
      }
    },
    setWeight: function(weight){
      const parsedWeight = parseScaleWeight(weight) || (!isNaN(parseFloat(weight)) ? parseFloat(weight).toFixed(3) : null);
      if (parsedWeight){
        const setQuantity = typeof this.typeQuantityNum === 'function' ? this.typeQuantityNum : this.typeNum;
        setQuantity(null, parsedWeight);
      } else if(weight !== ''){
        console.error('Weight should be in lb');
        // todo translate errors
        this.$store.dispatch('errorModal/displayModalError', {
          modalId: 'scale-error',
          errorBody: {
            title: 'Scales error',
            info: 'Weight should be in lb'
          }
        });
      }
    }
  }
};
